import { Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import MissingInformationForm from 'app/components/Core/LineItem/MissingInformation/Form'
import MissingInformationStepper from 'app/components/Core/LineItem/MissingInformation/Stepper'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { useIndex } from 'app/lib/hooks/useApi'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'

import Empty from './Empty'

type Props = {
  onSuccess?: () => void
  setSubtitle?: (subtitle: string) => void
}

const MissingInformationSteps: React.FC<MemberProps<IRental, Props>> = ({
  member,
  props: { onSuccess, setSubtitle }
}) => {
  const [currentStep, setCurrentStep] = useState(0)

  const {
    loading,
    execute,
    response: { data: stepperData }
  } = useIndex<ILineItem>(RecordType.line_item)
  const { formatMessage } = useIntl()
  const projectName = stepperData[0]?.project_name
  const status = stepperData[0]?.status

  useEffect(() => {
    execute({
      filters: {
        with_missing_information: true,
        rental_ids: [member.id],
        per_page: false
      },
      includes: [],
      serializer: 'base_serializer'
    })
  }, [])

  useEffect(() => {
    if (projectName) {
      setSubtitle?.(
        formatMessage(
          { id: 'component.feedback.drawer.subtitle.line_item.update' },
          { projectName }
        )
      )
    }
  }, [projectName])

  const handleSuccess = (response: ILineItem) => {
    if (stepperData[currentStep + 1]) {
      stepperData[currentStep] = response
      setCurrentStep(currentStep + 1)
    } else {
      onSuccess()
    }
  }

  return (
    <Row gutter={[12, 12]}>
      <KCol loading={loading} span={24}>
        <MissingInformationStepper
          collection={stepperData}
          current={currentStep}
          onChange={setCurrentStep}
        />
      </KCol>
      <KCol loading={loading} span={24}>
        <Choose>
          <When condition={stepperData[currentStep]}>
            <MissingInformationForm
              recordId={stepperData[currentStep].id}
              submitTitle={
                stepperData[currentStep + 1] &&
                formatMessage({ id: 'form.line_item.action.update_next' })
              }
              onSuccess={handleSuccess}
            />
          </When>
          <Otherwise>
            <Empty member={member} props={{ status }} />
          </Otherwise>
        </Choose>
      </KCol>
    </Row>
  )
}

export default MissingInformationSteps
